import _ from 'lodash';
import React, {FunctionComponent} from 'react';
import {useSelector} from 'react-redux';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {StoreAttributes} from '~/lib/directory';
import {selectStoresInOrganization} from '~/redux/selectors/organizationSelectors';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import StoreMatrixTable from './storeMatrixTable/StoreMatrixTable';
import {useOrgCatalogState} from '~/contexts/OrgCatalog/orgCatalogContext';

interface Props {
    open: boolean;
    products: ProductInCatalog[];
}

export const StoreMatrixView: FunctionComponent<Props> = (props: Props) => {
    const {products, open} = props;

    const stores = useSelector<GlobalApplicationState, StoreAttributes[] | undefined>(
        selectStoresInOrganization
    );

    const {fetching} = useOrgCatalogState();

    return (
        <div className={`store-matrix-container-${open && !fetching ? 'open' : 'closed'}`}>
            {_.size(stores) > 0 && <StoreMatrixTable products={products} stores={stores || []} />}
        </div>
    );
};

export default React.memo(StoreMatrixView);
